module.exports = __webpack_public_path__ + "static/img/hong.4b824fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hong.png
// module id = /8Ph
// module chunks = 73